import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNewCustomerLoginStore } from 'screens/NewCustomer/store/useNewCustomerLoginStore';
import { useTranslation } from 'react-i18next';
import useLogOut from 'hooks/useLogOut';
import { i18translation } from '../../../../locale/translations/i18NsPaths';
import UserFormInfo from '../UserFormInfo/UserFormInfo';
import { login } from '../../../../store/auth/auth.action';
import { routes } from '../../../../utils/constants/routes';
import * as S from './UserActivation.style';
import { badRequestStatus } from '../../../../utils/constants/api/statuses';
import { extractErrorAndShowToast } from '../../../../utils/helpers/extractErrorAndShowToast';
import { usersQueries } from '../../../../queryClient/users/users.queries';
import { errorMap } from './utils/UserActivation.constants';
import { usersMutations } from '../../../../queryClient/users/users.mutations';
import { useLoginContext } from '../../Login.context';
import { getQueryParam } from '../../../../utils/queryParam/getQueryParam';

const UserActivation = () => {
  const { performLogout } = useLogOut();
  const dispatch = useDispatch();
  const history = useHistory();
  const { search, pathname } = useLocation();
  const [errorCodeString, setErrorCodeString] = useState('');
  const [activationLinkSent, setActivationLinkSent] = useState(false);
  const newCustomerLoginStore = useNewCustomerLoginStore();
  const { mutate } = usersMutations.useResendUserActivationLink();
  const { t } = useTranslation();
  const keyPrefix = i18translation.LoginScreen;
  const showLoaderContext = useLoginContext();
  const [userQuery, setUserQuery] = useState('');

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(search);
    const redirectTo = urlSearchParams.get('rt');

    if (redirectTo) {
      window.sessionStorage.setItem('redirectTo', redirectTo);
    }

    const userActivation = urlSearchParams.get('userActivation');

    if (userActivation === '1') {
      urlSearchParams.delete('userActivation');
      setUserQuery(`?${urlSearchParams.toString()}`);
      showLoaderContext.setShowLoader(true);
    } else {
      urlSearchParams.set('userActivation', '1');
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      performLogout(`${pathname}?${urlSearchParams.toString()}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  usersQueries.useRegistrationCallback(userQuery, {
    enabled: !!userQuery,
    onSuccess: () => {
      // Set localstorage with data for next page - onboarding
      window.localStorage.setItem('rcPlan', getQueryParam('r'));
      dispatch(login({ callCsrfFlag: true }));
      newCustomerLoginStore.setIsFirstLogin(true);
    },
    onError: (err) => {
      errorCallback(err);
    },
    onSettled: () => {
      showLoaderContext.setShowLoader(false);
    }
  });

  const errorCallback = (errorCode) => {
    if (errorCode.response.status === badRequestStatus) {
      setErrorCodeString(errorCode.response.data?.errors?.code);
    } else {
      extractErrorAndShowToast(errorCode);
      history.push(routes.root);
    }
  };
  const sendNewActivationLink = () => {
    mutate(search, {
      onSuccess: () => {
        setActivationLinkSent(true);
      },
      onError: (err) => {
        errorCallback(err);
      }
    });
  };

  if (activationLinkSent) {
    return (
      <UserFormInfo
        title={t(keyPrefix.thanksForSignUp.thanksTitle)}
        subTitle={t(keyPrefix.thanksForSignUp.checkEmail)}
        text={t(keyPrefix.thanksForSignUp.checkEmailActivationMessage)}
        showBackToLoginButton={false}
      />
    );
  }

  if (errorCodeString === errorMap.alreadyActivated) {
    return <UserFormInfo title={t(keyPrefix.accountAlreadyActivated)} />;
  }

  if (errorCodeString === errorMap.keyExpired) {
    return (
      <UserFormInfo title={t(keyPrefix.userActivationLinkExpired)} showBackToLoginButton={false}>
        <S.SendNewActivationLinkBtn onClick={sendNewActivationLink}>
          {t(keyPrefix.sendNewActivationBtn)}
        </S.SendNewActivationLinkBtn>
      </UserFormInfo>
    );
  }

  return null;
};

export default UserActivation;
